import React, { useContext, useEffect, useState, Fragment } from "react";
import { Form,FormGroup,Accordion,Container } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { IClientnote } from "../../../../app/models/clientnote";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../../app/slider.css'

import { Image, Icon, Header, Divider, Label, ButtonContent } from "semantic-ui-react";

import config from '../../../../app/api/apiconfig';
import Axios from 'axios'
//
import oneOrderStore from "../../../../app/stores/oneOrderStore";
//import WorkOrderStore from "../../../../app/stores/workorderStore";

const baseURL = config.app.baseUrl
const integtokenUrl = config.app.integtokenUrl
const getclientnoteUrl = config.app.getclientnoteUrl
const azuremediaurl = config.app.getazuremediaUrl

const notesubjectfilterstring = "GilmNote"

interface IProps {}


const WorkOrderClientnoteGrid: React.FC<IProps> = props => {
  const workorderStore = useContext(oneOrderStore);
  //const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrder: workorder } = workorderStore;
  
  const [jobnumdata,setJobnumData] = useState();
  const [jobclientnotes,setJobclientnotesData] = useState([]);
  const [activeIndex, setActiveIndex] = useState();
  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };
  console.log('selectedWorkOrder',workorder.JobNo)
  //findClientdocsByJobNumber(workorder.JobNo);

  //get dyna token thru integrationapi 
  function getintegtoken(){
    let validToken = ""
    console.log ("getintegtokenUrl:", integtokenUrl.substring(0,29))
    Axios.get(integtokenUrl).then(response => {
          if(response.status === 200){
            var responsedata = response.data;
            if (responsedata != null && responsedata.length > 9) {
              validToken = responsedata
              sessionStorage.setItem('token', responsedata)
            }
          }
      });
    }

  //for the retrieve of clientnote thru dynamic
  function getClientnoteData(jobid){
    try
    {
      let validToken = ""
      if (sessionStorage.getItem("token")){
        validToken = sessionStorage.getItem("token")
        //console.log ("getsessionToken:", sessionStorage.getItem("token"))
      } else{
        getintegtoken()
        validToken = sessionStorage.getItem("token")
      }      
    
      let thisfilter = "$select=annotationid,notetext,subject,createdon&$filter=(objecttypecode eq 'msdyn_workorder' and filesize eq  0 and _objectid_value eq '" + jobid + "' and not startswith(subject, 'Interface+event') and not startswith(subject, 'Note+from+Origin') and not startswith(subject, 'Event+from+OriginHsg') and not startswith(subject, 'NewVersion+from+OriginHsg') and not contains(subject, 'AddeventFile') and not startswith(subject, '"+notesubjectfilterstring+"'))&$orderby=createdon desc&$top=99"
      let geturl = getclientnoteUrl + "?" + thisfilter
      let config  = {
            headers: {
              'Authorization': 'Bearer ' + validToken
            }
          }
          console.log('getapifilter',thisfilter)
          Axios.get(geturl, config)
            .then(response => {
                if(response.status === 200){
                  var getvalue = response.data.value;
                  console.log('get1stresp',getvalue);
                  if (getvalue == null || getvalue.length < 1){
                    getvalue = []
                    setJobclientnotesData(getvalue)
                  }
                  else{
                    setJobclientnotesData(getvalue)
                  }
                }
            }).catch((error) =>{
              if (error.response && error.response.status === 401) {
                  console.log('TokenError',error.response)
                  getintegtoken()
                  validToken = sessionStorage.getItem("token")
                  config  = {
                    headers: {
                      'Authorization': 'Bearer ' + validToken
                    }
                  }
                  Axios.get(geturl, config).then(response => {
                  if(response.status === 200){
                    var getvalue = response.data.value;
                    console.log('get2ndresp',getvalue);
                    if (getvalue == null){
                      getvalue = []
                      setJobclientnotesData(getvalue)
                    }
                    else{
                      setJobclientnotesData(getvalue)
                    }
                  }
                  })
              }
            })
        }
        catch(ex){
            console.error("An error has occurred for getClientnoteData: " + ex)
        }
      }

  //get check if selected order change
  function checkjobselectedchangedByJobNumber(jobNumber) {
    console.log(jobNumber != jobnumdata)
    if (jobNumber != null && jobNumber != jobnumdata) {
      console.log("new-job-selected", jobNumber)
      setJobnumData(jobNumber)
    }
  }

  const showNote = (notes: IClientnote[]) => {
    console.log('notes:', (notes != null && notes.length > 0) )
    if (notes != null && notes.length > 0) {
      var notelist = notes.map((item, index) => (
      <Fragment>
        <Accordion.Title
            active={activeIndex === index}
            index={index}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            {item.subject.substring(0,60)}...<div style={{float: "right"}}>{item.createdon}</div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <div>
            <br/>
            
            <b>{item.subject}</b>
            <br/><br/>
            {item.notetext}   
            </div>
          </Accordion.Content>
      </Fragment>
        
      ));
      return notelist;
    }
    else{
      
      return 'No Note';
    }
    
  };


  useEffect(() => {
    if (workorder != null && workorder.JobId != null) {
      getClientnoteData(workorder.JobId);
    }
  }, [workorder]);

  return (
    <div
      className="ag-theme-material"
      style={{ height: "300px", width: "100%" }}
    >
      <Accordion fluid styled>
        {showNote(jobclientnotes)}
      </Accordion>
    </div>
  );
};


export default observer(WorkOrderClientnoteGrid);